/**
 * QuickActions - Quick action buttons in FokusButton dropdown
 */

import React from 'react';
import { ActionableIcon } from './Icons';

const QuickActions = ({
  hasSelection,
  selectedCount,
  selectionLabel,
  actionableTaskIds,
  onFocusSelected,
  onActionableClick,
  clearAllFilters,
  setIsOpen,
}) => {
  const handleSelectionClick = () => {
    clearAllFilters();
    onFocusSelected();
    setIsOpen(false);
  };

  return (
    <div className="fokus-button__quick-section">
      <button
        className={`fokus-button__quick-option ${!hasSelection ? 'fokus-button__quick-option--disabled' : ''}`}
        onClick={handleSelectionClick}
        disabled={!hasSelection}
      >
        <span className="fokus-button__quick-icon">✓</span>
        <span className="fokus-button__quick-label">{selectionLabel}</span>
        <span className="fokus-button__quick-hint">
          {hasSelection ? `Focus on ${selectedCount} selected` : 'Select items first'}
        </span>
      </button>
      
      <button
        className={`fokus-button__quick-option fokus-button__quick-option--actionable ${actionableTaskIds.length === 0 ? 'fokus-button__quick-option--disabled' : ''}`}
        onClick={onActionableClick}
        disabled={actionableTaskIds.length === 0}
      >
        <span className="fokus-button__quick-icon"><ActionableIcon /></span>
        <span className="fokus-button__quick-label">Actionable Tasks</span>
        <span className="fokus-button__quick-hint">
          {actionableTaskIds.length} tasks ready to work on
        </span>
      </button>
    </div>
  );
};

export default QuickActions;
